import type { Node } from '@vue-flow/core'
import * as v from 'valibot'

export const ScenarioChatFormSchemaMap = {
  title: v.pipe(v.string(), v.trim(), v.nonEmpty('タイトルを入力してください')),
  message: {
    body: v.pipe(v.string(), v.trim(), v.nonEmpty('本文を入力してください')),
    selections: {
      basicSelections: {
        label: v.pipe(
          v.string(),
          v.trim(),
          v.nonEmpty('選択肢のテキストを入力してください')
        ),
        nextScenarioChatMessageClientOnlyId: v.undefinedable(v.string()),
      },
      bookingRequestSelections: {
        fallbackUrl: v.union([
          v.literal(''),
          v.pipe(v.string(), v.url('日程調整のURLの形式が不正です')),
        ]),
      },
    },
  },
}

export const ScenarioChatFormSchema_Message_SelectionsType_Basic =
  v.literal('BasicSelections')
export const ScenarioChatFormSchema_Message_SelectionsType_BookingRequest =
  v.literal('BookingRequestSelections')
export const ScenarioChatFormSchema_Message_SelectionsType_None =
  v.literal('None')

export const ScenarioChatFormSchema_Message_SelectionsType = v.union([
  ScenarioChatFormSchema_Message_SelectionsType_Basic,
  ScenarioChatFormSchema_Message_SelectionsType_BookingRequest,
  ScenarioChatFormSchema_Message_SelectionsType_None,
])

export type ScenarioChatForm_Message_SelectionsType = v.InferInput<
  typeof ScenarioChatFormSchema_Message_SelectionsType
>

export const ScenarioChatFormSchema_Message_BasicSelectionItem_Action_AssignPlannerAccount =
  v.object({
    type: v.literal('AssignStaff'),
    staffGUID: v.string(),
  })

export const ScenarioChatFormSchema_Message_BasicSelectionItem_Action = v.union(
  [
    ScenarioChatFormSchema_Message_BasicSelectionItem_Action_AssignPlannerAccount,
  ]
)

export type ScenarioChatForm_Message_BasicSelectionItem_Action = v.InferInput<
  typeof ScenarioChatFormSchema_Message_BasicSelectionItem_Action
>

export const ScenarioChatFormSchema_Message_BasicSelectionItem = v.object({
  guid: v.undefinedable(v.string()),
  clientOnlyId: v.string(),
  label: ScenarioChatFormSchemaMap.message.selections.basicSelections.label,
  actions: v.array(ScenarioChatFormSchema_Message_BasicSelectionItem_Action),
  nextScenarioChatMessageClientOnlyId:
    ScenarioChatFormSchemaMap.message.selections.basicSelections
      .nextScenarioChatMessageClientOnlyId,
})

export type ScenarioChatForm_Message_BasicSelectionItem = v.InferInput<
  typeof ScenarioChatFormSchema_Message_BasicSelectionItem
>

export const ScenarioChatFormSchema_Message_BasicSelections = v.object({
  type: ScenarioChatFormSchema_Message_SelectionsType_Basic,
  basicSelections: v.array(ScenarioChatFormSchema_Message_BasicSelectionItem),
})

export type ScenarioChatForm_Message_BasicSelections = v.InferInput<
  typeof ScenarioChatFormSchema_Message_BasicSelections
>

export const ScenarioChatFormSchema_Message_BookingRequestSelections = v.object(
  {
    type: ScenarioChatFormSchema_Message_SelectionsType_BookingRequest,
    fallbackUrl:
      ScenarioChatFormSchemaMap.message.selections.bookingRequestSelections
        .fallbackUrl,
  }
)

export type ScenarioChatForm_Message_BookingRequestSelections = v.InferInput<
  typeof ScenarioChatFormSchema_Message_BookingRequestSelections
>

export const ScenarioChatFormSchema_Message_NoneSelections = v.object({
  type: ScenarioChatFormSchema_Message_SelectionsType_None,
})

export type ScenarioChatForm_Message_NoneSelections = v.InferInput<
  typeof ScenarioChatFormSchema_Message_NoneSelections
>

export const ScenarioChatFormSchema_Message = v.object({
  guid: v.undefinedable(v.string()),
  clientOnlyId: v.string(),
  forUserIndex: v.number(), // ユーザーがメッセージノードを識別しやすくするための index
  isEntry: v.boolean(),
  body: ScenarioChatFormSchemaMap.message.body,
  selections: v.union([
    ScenarioChatFormSchema_Message_BasicSelections,
    ScenarioChatFormSchema_Message_BookingRequestSelections,
    ScenarioChatFormSchema_Message_NoneSelections,
  ]),
})

export type ScenarioChatForm_Message = v.InferInput<
  typeof ScenarioChatFormSchema_Message
>

export const ScenarioChatFormSchema = v.object({
  title: ScenarioChatFormSchemaMap.title,
  messages: v.record(v.string(), ScenarioChatFormSchema_Message),
})

export type ScenarioChatForm = v.InferInput<typeof ScenarioChatFormSchema>

//
// Vue Flow の Graph 系の型
//
export type ScenarioChatNode = ScenarioChatMessageNode

export type ScenarioChatMessageNode = Node<
  ScenarioChatMessageNodeData,
  any,
  'message'
>

export type ScenarioChatMessageNodeData = {
  message: ScenarioChatForm_Message
  isEntry: boolean
}
